import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Breakpoint from '@/components/Breakpoint';

import Wiener from './Wiener';

function WienersDemo() {
  const [showEncouragement, setShowEncouragement] =
    React.useState(true);

  const hideEncouragement = React.useCallback(() => {
    setShowEncouragement(false);
  }, []);

  return (
    <Wrapper>
      <WienerWrapper>
        <Wiener color="purple" onInteract={hideEncouragement} />
        <Encouragement
          style={{
            opacity: showEncouragement ? 1 : 0,
            pointerEvents: showEncouragement ? 'auto' : 'none',
          }}
        >
          <Arrow
            alt=""
            src="/images/interactive-guide-to-flexbox/arrow.png"
          />
          Drag me!
        </Encouragement>
      </WienerWrapper>

      <WienerWrapper>
        <Wiener color="green" onInteract={hideEncouragement} />
      </WienerWrapper>

      <Breakpoint breakpoint="mdAndLarger">
        <WienerWrapper>
          <Wiener color="red" onInteract={hideEncouragement} />
        </WienerWrapper>
      </Breakpoint>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 24px;
  margin-top: 48px;
  margin-bottom: 96px;
`;

const WienerWrapper = styled.div`
  position: relative;
  max-width: 200px;
`;

const Encouragement = styled.div`
  position: absolute;
  left: 40px;
  right: 0;
  bottom: -24px;
  animation: levitate 4000ms infinite cubic-bezier(0.31, 0, 0.4, 0.99);
  transition: opacity 500ms;
  font-size: 1.25rem;
  font-weight: var(--font-weight-bold);

  @keyframes levitate {
    0% {
      transform: translateY(10px);
    }
    16% {
      transform: translateY(0px);
    }
    32% {
      transform: translateY(10px);
    }
    48% {
      transform: translateY(0px);
    }
    64% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(10px);
    }
  }

  @media ${BREAKPOINTS.smAndSmaller} {
    display: none;
  }
`;

const Arrow = styled.img`
  display: block;
  width: 36px;
  height: 92px;
  position: absolute;
  transform: translate(-120%, -75%);
`;

export default WienersDemo;
